module.exports = __webpack_public_path__ + "img/checkboxEle.8739434f.svg";